import { render, staticRenderFns } from "./myBookMark.vue?vue&type=template&id=74901ddb&scoped=true&"
import script from "./myBookMark.vue?vue&type=script&lang=js&"
export * from "./myBookMark.vue?vue&type=script&lang=js&"
import style0 from "./myBookMark.vue?vue&type=style&index=0&id=74901ddb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74901ddb",
  null
  
)

export default component.exports